import React, { RefObject, useState } from 'react';
import Slider from 'Shared/SharedComponents/atoms/Slider';

type PropType = {
  mediaRef: RefObject<HTMLMediaElement>;
};

const TimeControls = ({ mediaRef }: PropType) => {
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(1);

  const interval = setInterval(() => {
    if (mediaRef.current && mediaRef.current.readyState > 0) {
      setCurrentTime(mediaRef.current.currentTime);
      setDuration(mediaRef.current.duration);

      clearInterval(interval);
    }
  }, 200);

  const skipToTime = (selectedTime: number) => {
    if (mediaRef.current) {
      const newTime = Math.min(Math.max(selectedTime, 0), duration);
      mediaRef.current.currentTime = newTime;
      setCurrentTime(newTime);
    }
  };

  return (
    <Slider
      min={0}
      max={1000}
      value={(currentTime * 1000) / duration}
      updateValue={(selectedValue) => {
        skipToTime((selectedValue * duration) / 1000);
      }}
    />
  );
};

export default TimeControls;
